var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "far fa-user" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("user")) + "\n\t")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-xs" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            ref: "full_name",
            attrs: {
              "float-label": "" + _vm.$t("name_and_last_name"),
              error: _vm.$v.full_name.$error
            },
            on: { input: _vm.$v.full_name.$touch },
            model: {
              value: _vm.full_name,
              callback: function($$v) {
                _vm.full_name = $$v
              },
              expression: "full_name"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.email_error,
                "error-label": "" + _vm.$t("email_not_unique")
              }
            },
            [
              _c("q-input", {
                ref: "email",
                attrs: {
                  type: "email",
                  "float-label": "" + _vm.$t("email"),
                  error: _vm.$v.email.$error
                },
                on: {
                  input: _vm.$v.email.$touch,
                  blur: function($event) {
                    return _vm.emailUnique()
                  }
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.document_error,
                "error-label": _vm.$t("document_not_unique")
              }
            },
            [
              _c("q-input", {
                ref: "document",
                attrs: {
                  "float-label": "" + _vm.$t("document"),
                  error: _vm.$v.document.$error
                },
                on: {
                  input: _vm.$v.document.$touch,
                  blur: function($event) {
                    return _vm.documentUnique()
                  }
                },
                model: {
                  value: _vm.document,
                  callback: function($$v) {
                    _vm.document = $$v
                  },
                  expression: "document"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-select", {
            ref: "profile",
            attrs: {
              filter: "",
              "autofocus-filter": "",
              error: _vm.$v.profile.$error,
              options: _vm.getProfileOptions(),
              "float-label": "" + _vm.$t("profile")
            },
            on: { input: _vm.$v.profile.$touch },
            model: {
              value: _vm.profile,
              callback: function($$v) {
                _vm.profile = $$v
              },
              expression: "profile"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.clearAndClose()
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "positive",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }